// @flow
import React from "react";

type Props = {
  onClick?: () => void
};

export default function Close({ width = 20, ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.414 21.414"
      width={width}
      height={width}
      strokeWidth="2px"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <g transform="translate(-79.293 0.707)">
        <line x2="20" y2="20" transform="translate(80 0)" />
        <line x1="20" y2="20" transform="translate(80 0)" />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icons/Close.js